function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGoogleGroups = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "basic",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#2196f3"
  },
  d: "M18.999 35.499v-1.992c0-7.452 6.048-13.507 13.5-13.507s13.5 6.055 13.5 13.507v1.992c0 1.38-1.12 2.501-2.5 2.501h-22a2.501 2.501 0 0 1-2.5-2.501zM32.499 5.003c3.588 0 6.5 2.916 6.5 6.504a6.506 6.506 0 0 1-6.5 6.504 6.506 6.506 0 0 1-6.5-6.504 6.506 6.506 0 0 1 6.5-6.504z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#2196f3"
  },
  d: "M1.999 44.001V33.505c0-7.452 6.048-13.507 13.5-13.507 3.225 0 6.187 1.133 8.509 3.024l-2.393 14.976h-8.787l-7.417 7.417a2 2 0 0 1-3.412-1.414zM15.499 5.001c3.588 0 6.5 2.916 6.5 6.504 0 3.588-2.912 6.504-6.5 6.504s-6.5-2.916-6.5-6.504a6.506 6.506 0 0 1 6.5-6.504z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1574c0"
  },
  d: "M18.999 35.499v-1.992c0-4.232 1.951-8.013 5.001-10.491a13.487 13.487 0 0 1 4.999 10.488v1.992c0 1.38-1.12 2.501-2.5 2.501h-5.125a2.5 2.5 0 0 1-2.375-2.498z"
}));

const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleGroups);
export default ForwardRef;